let tokenCheckTimer: number | undefined;

export function stopTokenRefresher() {
  if (tokenCheckTimer !== undefined) {
    clearTimeout(tokenCheckTimer);
    tokenCheckTimer = undefined;
  }
}

export function setTokenRefresherTimer(callback: () => void, ms: number) {
  stopTokenRefresher();
  tokenCheckTimer = window.setTimeout(callback, ms);
}

export function isTokenRefresherActive(): boolean {
  return tokenCheckTimer !== undefined;
}
